import axios from 'axios';
const instance = axios.create(
  {
    headers: {
      "X-Api-Key": "W5vcnRoZWFzdC0xX1RJY1FSWXvknf9brez",
    }
  }
);
export default instance
